import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../api/client';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    let timer = null;
    const executePayment = async () => {
      const paymentId = searchParams.get('paymentId');
      const payerId = searchParams.get('PayerID');

      if (paymentId && payerId) {
        try {
          await api.post('/api/paypal/execute', {
            paymentId,
            payerId
          });

          timer = setTimeout(() => {
            navigate('/subscription');
          }, 2000);
        } catch (error) {
          console.error('Payment error:', error);
          setProcessing(false);
        }
      }
    };

    executePayment();
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [navigate, searchParams]);

  return (
    <div style={{ textAlign: 'center', padding: '4rem' }}>
      {processing ? (
        <>
          <h1>✅ Payment Successful!</h1>
          <p>Activating your subscription...</p>
        </>
      ) : (
        <>
          <h1>❌ Payment Error</h1>
          <p>Something went wrong.</p>
        </>
      )}
    </div>
  );
};

export default PaymentSuccess;

